var Rut = {
	// Valida el rut con su cadena completa "XXXXXXXX-X"
	validaRut : function (rutCompleto) {
		if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test( rutCompleto ))
			return false;
		var tmp 	= rutCompleto.split('-');
		var digv	= tmp[1]; 
		var rut 	= tmp[0];
		if ( digv == 'k' ) digv = 'K' ;
		return (Rut.dv(rut) == digv );
	},
	
	// Calcula el dígito verificador
	dv : function(T){
		var M=0,S=1;
		for(;T;T=Math.floor(T/10))
			S=(S+T%10*(9-M++%6))%11;
		return S?S-1:'K';
	},
	
	// Valida que el número sea un entero
	validaEntero : function  ( value ) {
      var RegExPattern = /[0-9]+$/;
      return RegExPattern.test( value );
    },
	
	// Formatea un número con puntos de miles
    formateaNumero : function ( value ) {
        if ( Rut.validaEntero ( value ) )  {  
        var retorno = '';
        value = value.toString().split('').reverse().join('');
        var i = value.length;
        while(i>0) retorno += ((i%3==0&&i!=value.length)?'.':'')+value.substring(i--,i);
        return retorno;
        }
        return value;
    }
}

export {Rut};
